import { MouseEvent } from 'react';
import { useIntl } from 'react-intl';

import {
    useLazyExperimentVariation,
    useTrackEventAmplitude,
} from '../../../../core/Tracking/Amplitude/Amplitude';
import { IconStars } from '../../../../design-system/components/icons/Stars';
import { Typography } from '../../../../design-system/components/typography/Typography';
import { useUrlGenerator } from '../../../../shared/hooks/useUrlGenerator';

import style from './WhereToGoButton.module.css';

export function WhereToGoButton() {
    const { generatePath } = useUrlGenerator();
    const { trackEvent } = useTrackEventAmplitude();
    const { formatMessage } = useIntl();
    const getOrFetchVariant = useLazyExperimentVariation('fr-hp-wheretogo-conversation');

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        trackEvent((ampli, defaultProperties) => {
            ampli.wheretogoClicked({
                ...defaultProperties,
                block: 'cover',
            });
        });
        void getOrFetchVariant().then((variant) => {
            if (variant?.value === 'variation') {
                window.location.href = 'https://where-to-go.evaneos.fr';
            } else {
                window.location.href = generatePath('where_to_go');
            }
        });
    };

    return (
        <Typography
            as="a"
            scale="primary-body-regular"
            className={style.whereToGoButton}
            href={generatePath('where_to_go')}
            onClick={handleClick}
        >
            {formatMessage({ id: 'page.home.coverCta.ouPartir' })}
            <IconStars className={style.starsIcon} />
        </Typography>
    );
}
